import { FC } from 'react'
import { MainLayout } from 'views/layouts'
import { Link } from 'react-router-dom'
import { Card, ModulesContainer, CardIconSection, Icon, CardDescriptionSection, CardTitle } from './styled'
import brainImage from 'assets/images/icon-betesa-card.png'
import boxImage from 'assets/images/icon-skills-card.png'
// import threeSixtyImage from 'assets/images/icon-test360-card.png'
import Generales from '../../components/assets/generales.png'
import Familia from '../../components/assets/rolFamily.png'
import { superAdminRoutes } from 'router/routes'
import { useTranslation } from 'react-i18next'
import { StrokedButton } from 'views/components/UI/Buttons'

const Modules: FC = () => {
  const { t } = useTranslation()
  return (
    <MainLayout>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          marginBottom: 35,
          marginTop: 50,
          alignItems: 'baseline',
        }}
      >
        <h2 style={{ fontSize: 32, marginBottom: 0 }}>Módulos</h2>
        <p style={{ fontSize: '18px', marginBottom: 0 }}>Selecciona un módulo para empezar a configurarlo</p>
      </div>

      <ModulesContainer>
        <Card>
          <CardIconSection>
            <Icon src={brainImage} alt="modulo" />
          </CardIconSection>
          <CardDescriptionSection>
            <CardTitle>Betesa</CardTitle>
            <Link to="/modules/talents">
              <StrokedButton
                style={{ width: 'fit-content', padding: '8px 16px', boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.1)' }}
              >
                Ver detalles
              </StrokedButton>
            </Link>
          </CardDescriptionSection>
        </Card>
        <Card>
          <CardIconSection>
            <Icon src={boxImage} alt="modulo" />
          </CardIconSection>
          <CardDescriptionSection>
            <CardTitle>{t('global.common.skillText')}</CardTitle>
            <Link to="/modules/skills">
              <StrokedButton
                style={{ width: 'fit-content', padding: '8px 16px', boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.1)' }}
              >
                Ver detalles
              </StrokedButton>
            </Link>
          </CardDescriptionSection>
        </Card>
        {/*  <Card>
          <CardIconSection>
            <Icon src={threeSixtyImage} alt="modulo" />
          </CardIconSection>
          <CardDescriptionSection>
            <CardTitle>{t('global.common.threeSixtyText')}</CardTitle>
            <Link to="/modules/skills">
              <StrokedButton
                style={{ width: 'fit-content', padding: '8px 16px', boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.1)' }}
              >
                Ver detalles
              </StrokedButton>
            </Link>
          </CardDescriptionSection>
        </Card> */}
      </ModulesContainer>
      <hr style={{ border: '1px solid #919EAB', marginTop: 20, marginBottom: 20 }} />
      <p style={{ color: '#1F2124', fontSize: '18px', fontWeight: 'bold', marginBottom: 20 }}>Pre - Configuración</p>
      <Link to={superAdminRoutes.RoleFamily}>
        <Card>
          <CardIconSection>
            <Icon style={{ marginTop: 4 }} src={Familia} alt="Familia de rol" />
          </CardIconSection>
          <CardDescriptionSection>
            <CardTitle>Familia de rol</CardTitle>
          </CardDescriptionSection>
        </Card>
      </Link>

      <hr style={{ border: '1px solid #919EAB', marginTop: 20, marginBottom: 20 }} />
      <p style={{ color: '#1F2124', fontSize: '18px', fontWeight: 'bold', marginBottom: 20 }}>Textos</p>
      <Link to="/modules/texts/create">
        <Card>
          <CardIconSection>
            <Icon style={{ marginLeft: 10, marginTop: 10 }} src={Generales} alt="generales" />
          </CardIconSection>
          <CardDescriptionSection>
            <CardTitle>Generales</CardTitle>
          </CardDescriptionSection>
        </Card>
      </Link>
    </MainLayout>
  )
}
export default Modules
